<template>
  <div id="app">

    <!-- <keep-alive >


    </keep-alive> -->
    <!-- <router-view ></router-view> -->
    <!-- <router-view v-if="!$route.meta.keepAlive" style="min-height:100%"></router-view> -->
    <!-- v-if="$route.meta.keepAlive" style="min-height:100%" -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.fullPath;
      // return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  },


}

</script>

<style lang="scss">
.dialog-bg {
  .el-dialog {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue